import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';
import { SeedingProposalDeliveryAddressSchema } from './seedingMutationSchemas';

const UpdateDeliveryAddressRequestSchema = z
  .object({
    campaignId: z.number().int(),
    /** 배송지 수정 body — 신청/수락 deliveryAddress 와 동일 형태(SeedingProposalDeliveryAddress). */
    body: SeedingProposalDeliveryAddressSchema,
  })
  .describe('UpdateDeliveryAddressRequest');

export type UpdateDeliveryAddressRequest = z.infer<typeof UpdateDeliveryAddressRequestSchema>;

/** 수정 직후 배송지 — source 는 항상 ORDER_SNAPSHOT. */
const UpdateSeedingDeliveryAddressSchema = z
  .object({
    source: z.enum(['DEFAULT', 'ORDER_SNAPSHOT']),
    deliveryAddressId: z.number().int().nullable().optional(),
    addressName: z.string().nullable().optional(),
    name: z.string(),
    phone: z.string(),
    zipcode: z.string(),
    address1: z.string(),
    address2: z.string().nullable().optional(),
    memo: z.string().nullable().optional(),
  })
  .describe('UpdateSeedingDeliveryAddress');

const UpdateDeliveryAddressResponseSchema = createApiResponseSchema(
  UpdateSeedingDeliveryAddressSchema,
);

export type UpdateDeliveryAddressResponse = z.infer<typeof UpdateDeliveryAddressResponseSchema>;

/**
 * 시딩 캠페인 배송지 수정 (PUT `/v2/curator/campaign/seeding/{campaignId}/delivery`).
 * 선택한 배송지를 캠페인에 서버 영속화 → 상세 재조회 시 반영(라우트 왕복에도 유지).
 */
export const updateDeliveryAddress = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(UpdateDeliveryAddressRequestSchema),
    async ({
      campaignId,
      body,
    }: UpdateDeliveryAddressRequest): Promise<UpdateDeliveryAddressResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.put<UpdateDeliveryAddressResponse>(
          urlJoin(campaignsApiPath.updateDeliveryAddress(campaignId)),
          body,
        ),
      ),
    validateApiResponse(UpdateDeliveryAddressResponseSchema),
  ),
);
